export default __webpack_public_path__ + "static/media/Tani.f5aed0f5.jpg";